import { useState, useCallback } from 'react';

export const useErrorBoundary = () => {
  const [error, setError] = useState(null);

  // If there's an error state, throw it during rendering so Error Boundary catches it
  if (error) {
    throw error.error;
  }

  const handleError = useCallback((err, errorInfo = null) => {
    console.error('Error caught by hook:', err, errorInfo);
    setError({ error: err, errorInfo, timestamp: new Date() });
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return { error, handleError, clearError };
};